<script lang="ts">
	import type { PartnerLinkProps } from '$lib/components/advertising/partners/partnerLink/types';
	import PartnerLink from '$lib/components/advertising/partners/partnerLink/PartnerLink.svelte';
	import { generateRandomNumber } from '$lib/components/advertising/utils';
	import Image from '$lib/components/atoms/image/Image.svelte';
	import ObfuscatedLink from '$lib/components/atoms/obfuscatedLink/ObfuscatedLink.svelte';
	import { onMount } from 'svelte';

	interface Props {
		partnerName?: string;
		title?: string;
		description?: string;
		nextDescription?: string;
		brandImage: { srcset?: string };
		cta?: PartnerLinkProps | undefined;
		legalNotice?: string;
		textStyle?: string;
		backgroundStyle?: string;
		onclick?: () => void;
		onMount?: () => void;
	}

	const {
		partnerName,
		title,
		description,
		nextDescription,
		brandImage,
		cta,
		legalNotice,
		textStyle,
		backgroundStyle,
		onclick,
		onMount: emitOnMount,
	}: Props = $props();

	const brandImageSrcset = $derived(brandImage?.srcset);
	const brandImageSrc = $derived(brandImageSrcset
		? brandImageSrcset?.split(',')?.at(-1)?.trim()?.split(' ')?.at(0)
		: undefined);

	let showClickTag = $state(false);

	onMount(() => {
		emitOnMount?.();
	});
</script>

<ObfuscatedLink
	href={cta?.href}
	target="_blank"
	rel="noopener"
	class="cursor-pointer lt-md:w-full"
	onclick={() => {
		onclick?.();

		if (cta?.clickUrl) {
			showClickTag = true;
		}
	}}
>
	<div
		class="h-full min-w-50 border-rd-2 p-4 justify-between flex flex-col"
		data-testid="partner-card-{partnerName}"
		style={backgroundStyle}
	>
		<div class="flex flex-col">
			{#if brandImageSrc}
				<div>
					<Image src={brandImageSrc} srcset={brandImageSrcset} alt={title || ''} class="h-6.5" />
				</div>
			{/if}
			{#if title}
				<h2 class="text-lg my-2" style={textStyle}>
					{title}
				</h2>
			{/if}
			{#if description}
				<p class="text-md m-y-2" style={textStyle}>{description}</p>
			{/if}
			{#if nextDescription}
				<p class="text-md m-y-2" style={textStyle}>{nextDescription}</p>
			{/if}
			{#if cta}
				<div class="text-left">
					<PartnerLink data={cta} />
					{#if showClickTag && cta?.clickUrl}
						<Image
							src={cta.clickUrl.replace('{{randomId}}', generateRandomNumber().toString())}
							width="1"
							height="1"
							alt=""
						/>
					{/if}
				</div>
			{/if}
			{#if legalNotice}
				<div class="p-t-3 text-2.25 line-height-3.0725" style={textStyle}>
					{legalNotice}
				</div>
			{/if}
		</div>
	</div>
</ObfuscatedLink>
